var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5326 36.5056H19.6685V17.4944H24.5326V36.5056ZM34.3315 36.2124V17.4944H29.4674V36.5157H34.3315V36.2225V36.2124ZM27 54C12.1146 54 0 41.8854 0 27C0 12.1146 12.1146 0 27 0C41.8854 0 54 12.1146 54 27C54 41.8854 41.8854 54 27 54ZM27 1.41573C12.8933 1.41573 1.41573 12.8933 1.41573 27C1.41573 41.1067 12.8933 52.5843 27 52.5843C41.1067 52.5843 52.5843 41.1067 52.5843 27C52.5843 12.8933 41.1067 1.41573 27 1.41573Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/Pause.9dbb06952096808fba139462539fc67d.svg";
export { ForwardRef as ReactComponent };